<template>
  <cec-select-search
    v-model="internalValue"
    :options="options"
    :state="state"
    :disabled="disabled || loading"
    :placeholder="placeholder"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import CecSelectSearch from './CecSelectSearch.vue'
import axios from 'axios'

export default {
  name: 'VendedorDropdown',
  components: { CecSelectSearch },
  inheritAttrs: false, // importante pra não “grudar” attrs no wrapper errado

  props: {
    value: { type: [String, Number, null], default: null },
    state: { type: [Boolean, null], default: null },
    disabled: { type: Boolean, default: false },
    placeholder: { type: String, default: 'Pesquise pelo nome do vendedor...' }
  },

  data () {
    return { internalValue: this.value, options: [], loading: false }
  },

  watch: {
    value (v) { this.internalValue = v },
    internalValue (v) { this.$emit('input', v); this.$emit('change', v) }
  },

  created () { this.fetchVendedores() },

  methods: {
    fetchVendedores () {
      var self = this
      self.loading = true
      axios.get('/api/protected/vendedor/getAtivos')
        .then(function (r) {
          var data = r.data || []
          self.options = data.map(function (item) {
            return { value: item.ID, text: item.CODIGONOME }
          })
        })
        .finally(function () { self.loading = false })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/componentes/dropdown/VendedorDropdown.vue